import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/work/ProjectDetailLayout.tsx");
